import { ListingData } from '../../stores/ListingStore'

export const canListingPublish = (listing: ListingData) => !listing.isPublished

export const canListingUnpublish = (listing: ListingData) => {
  return listing.isPublished
}
